import { render, staticRenderFns } from "./UserNote.vue?vue&type=template&id=870cdda4"
import script from "./UserNote.vue?vue&type=script&lang=js"
export * from "./UserNote.vue?vue&type=script&lang=js"
import style0 from "./UserNote.vue?vue&type=style&index=0&id=870cdda4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports